export default class AdminConsultationReports {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  fetchConsultationGraph(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/consultation-graph`, {
      params
    })
  }

  fetchConsultationReport(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/consultation`, {
      params
    })
  }

  exportConsultationReport(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/consultation/export/all`, {
      params,
      responseType: "blob"
    })
  }
}
